export default {
    name: 'account--fias',
    apiService: 'shoes',
    apiPath: '/admin/fias',
};